export interface CustomDictionaryMock {
  id: string;
  name: string;
  icon: string;
  accent: string;
  total: number;
  learned: number;
  /** ISO date — when the dictionary was last touched. */
  lastTouched: string;
}

/**
 * Custom user-created dictionaries — UI-only mock until the BE exposes them.
 * Wired into the "Мої словники" section to stress-test the layout; the
 * Create / Edit / Delete controls are dead in this state by design.
 */
export const MOCK_CUSTOM_DICTIONARIES: CustomDictionaryMock[] = [
  {
    id: 'business',
    name: 'Бізнес-англійська',
    icon: 'work',
    accent: '#488BFF',
    total: 73,
    learned: 30,
    lastTouched: '2026-06-16',
  },
  {
    id: 'it',
    name: 'IT та розробка',
    icon: 'code',
    accent: '#9B7CFF',
    total: 112,
    learned: 64,
    lastTouched: '2026-06-12',
  },
  {
    id: 'travel',
    name: 'Подорожі',
    icon: 'flight',
    accent: '#F2B14C',
    total: 45,
    learned: 12,
    lastTouched: '2026-05-30',
  },
  {
    id: 'series',
    name: 'Серіал «Friends»',
    icon: 'movie',
    accent: '#E2330A',
    total: 38,
    learned: 5,
    lastTouched: '2026-06-09',
  },
];
